import { IbdProductUpdateEvent } from '@theme/ibd-events';

class IbdProductObserver extends HTMLElement {
  /** @type {MutationObserver|null} */
  observer = null;

  connectedCallback() {
    this.#startObserver();
  }

  disconnectedCallback() {
    this.#stopObserver();
  }

  /**
   * Dispatches a product update event when the data-product-id attribute changes.
   * This happens when morphing the main content, usually if a combined listing product has changed.
   */
  #dispatchProductUpdateEvent() {
    const main = document.querySelector('#MainContent');
    if (!main || !(main instanceof HTMLElement)) return;

    const html = new DOMParser().parseFromString(main.innerHTML, 'text/html');
    const productId = this.dataset.productId ?? '';

    if (!html || !productId) {
      throw new Error('IBD | Product Observer | #dispatchProductUpdateEvent | No HTML or product ID found');
    }

    this.dispatchEvent(new IbdProductUpdateEvent({ html, productId }));
  }

  /**
   * Starts observing changes to the data-product-id attribute.
   */
  #startObserver() {
    if (this.observer) return;

    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-product-id') {
          this.#dispatchProductUpdateEvent();
        }
      });
    });

    this.observer.observe(this, { attributes: true, attributeFilter: ['data-product-id'] });
  }

  /**
   * Stops the main product observer.
   */
  #stopObserver() {
    if (!this.observer) return;
    this.observer.disconnect();
    this.observer = null;
  }
}

if (!customElements.get('ibd-product-observer')) {
  customElements.define('ibd-product-observer', IbdProductObserver);
}
